import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";
import { IPricing } from "@/app/domain";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { Overheads } from "@/app/domain/entities/overhead";

export class ServicesSumCalculationStrategy extends CalculationStrategy {
    calculate = (component: Overheads, [deliverySum, discountPercent, isIncludeCombinedDeliveryInPrice, halfInstallation, isHalfInstallation]): PriceResult => {
        return {
            price: this.calculateOverheadWithDiscount(deliverySum, discountPercent, isIncludeCombinedDeliveryInPrice, halfInstallation, isHalfInstallation, CostDealType),
            priceB2C: this.calculateOverheadWithDiscount(deliverySum, discountPercent, isIncludeCombinedDeliveryInPrice, halfInstallation, isHalfInstallation, B2CDealType),
            priceB2B: this.calculateOverheadWithDiscount(deliverySum, discountPercent, isIncludeCombinedDeliveryInPrice, halfInstallation, isHalfInstallation, B2BDealType),
        };
    };

    private calculateOverheadWithDiscount(
        deliverySum: number,
        discountPercent: number,
        isIncludeCombinedDeliveryInPrice: boolean,
        halfInstallation: number | IPricing,
        isHalfInstallation: boolean,
        dealType: string,
    ) {
        const deliveryPriceWithDiscount = isIncludeCombinedDeliveryInPrice ? deliverySum / (100 - discountPercent) * 100 : 0

        const halfInstallationPrice = typeof halfInstallation === "number" ? halfInstallation : halfInstallation?.getSystemPrice(dealType).getValue();

        const installationPriceWithDiscount = isHalfInstallation ? halfInstallationPrice / (100 - discountPercent) * 100 : 0;

        const sum = deliveryPriceWithDiscount + installationPriceWithDiscount;
        return +sum.toFixed(2);
    }
}
